import { render, staticRenderFns } from "./TrainType.vue?vue&type=template&id=3c9f19a2&scoped=true"
import script from "./TrainType.vue?vue&type=script&lang=js"
export * from "./TrainType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9f19a2",
  null
  
)

export default component.exports